export default __webpack_public_path__ + "assets/audio/ssml/prosody.c4bf69275607057012bf3bf4a8dfec30.mp3";